import { Point } from 'geojson';

import { fromGoogleMapLatLng, fromGoogleMapLatLngBounds } from '@lib/geo/google/map';
import { SnLonLat, SnLonLatBounds } from '@lib/geo/helpers';

import { SnGoogleGeocoderAddressComponents } from './google-geocoder-address-component.model';

export class SnGoogleGeocoderResult {
  public id: string;
  public name: string;
  public formattedAddress: string;
  public addressComponents: SnGoogleGeocoderAddressComponents;

  public lonLat: SnLonLat;
  public latLngBounds: SnLonLatBounds;
  public geometry: Point;

  constructor(data: google.maps.GeocoderResult) {
    this.id = data.place_id;
    this.formattedAddress = data.formatted_address;
    this.addressComponents = new SnGoogleGeocoderAddressComponents(data.address_components);

    this._decodeGeometry(data.geometry);
  }

  private _decodeGeometry(geometry: google.maps.GeocoderGeometry): void {
    this.lonLat = fromGoogleMapLatLng(geometry.location);
    this.geometry = this.lonLat.toGeojsonPoint();

    if (geometry.bounds) {
      this.latLngBounds = fromGoogleMapLatLngBounds(geometry.bounds);
    }
  }
}
